import React, { useEffect, useRef } from 'react';
import './Sigiriya.css';
import jaffna1 from '../../img/webp/jaffna1.webp';
import jaffna2 from '../../img/webp/jaffna2.webp';
import jaffna3 from '../../img/webp/jaffna3.webp';
import jaffna4 from '../../img/webp/jaffna4.webp';
import DestinationSuggestions from '../../components/DestinationSuggestions';
import { getRandomSuggestions } from '../../data/destinationsData';
import SearchBar from '../../components/SearchBar';

const Jaffna: React.FC = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="destination-page">
      <SearchBar contentRef={contentRef} placeholder="Search Jaffna information..." />
      
      <div ref={contentRef}>
      <section className="dest-hero">
        <img src={jaffna1} alt="Jaffna" />
        <div className="dest-badge">Jaffna</div>
      </section>

      <section className="dest-content">
        <div className="dest-container">
          <div className="dest-main-section">
            <div className="dest-left">
              <img
                src={jaffna2}
                alt="Jaffna Temple"
              />
            </div>
            <div className="dest-right">
              <h1 className="dest-title">Why Visit Jaffna?</h1>
              <p className="dest-description">
                Jaffna is a unique city in northern Sri Lanka known for its distinct Tamil culture, ancient temples, and colonial influences. The region offers a deep cultural experience different from other parts of the island.
              </p>
              <ul className="dest-features">
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Cultural and heritage-focused travel
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Guided city exploration
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Comfortable travel arrangements
                </li>
              </ul>
              <div className="dest-meta">
                <span>🚗 Land Trip</span>
                <span>📅 2 Days</span>
                <span>🎯 Cultural Tour</span>
              </div>
            </div>
          </div>

          <div className="dest-bottom-section">
            <div className="dest-bottom-left">
              <p className="dest-bottom-text">
                Jaffna is a culturally rich city in northern Sri Lanka, known for its distinct Tamil heritage, ancient Hindu temples, and colonial architecture. The region offers a unique cultural experience different from other parts of the island, showcasing traditional festivals, authentic cuisine, and historical landmarks.
              </p>
              <p className="dest-bottom-text">
                Visitors can explore Nallur Kandaswamy Temple, Jaffna Fort, Jaffna Library, and scenic islands like Delft and Nainativu. The city reflects resilience, tradition, and a strong cultural identity, making it an enriching and educational travel destination.
              </p>
            </div>
            <div className="dest-bottom-right">
              <img
                src={jaffna3}
                alt="Jaffna Culture"
              />
            </div>
          </div>

          {/* Ceylon D Tour Section */}
          <div className="dest-main-section" style={{ marginTop: '4rem' }}>
            <div className="dest-left">
              <img
                src={jaffna4}
                alt="Ceylon D Tour Jaffna experience"
              />
            </div>
            <div className="dest-right">
              <p className="dest-description">
                Ceylon D Tour provides specialized Jaffna cultural tours with comfortable transportation, knowledgeable local guides, and culturally sensitive itineraries. Our packages include temple visits, historic site explorations, island excursions, and authentic cuisine experiences. With Ceylon D Tour, you can discover Jaffna's unique Tamil heritage, colonial history, and vibrant culture with personalized service, respect for local traditions, and seamless travel arrangements.
              </p>
            </div>
          </div>

          {/* Destination Suggestions */}
          <DestinationSuggestions 
            currentDestination="Jaffna"
            suggestions={getRandomSuggestions('/places/jaffna', 4)}
          />
        </div> {/* End of dest-container */}
      </section>
      </div>
    </div>
  );
};

export default Jaffna;

